module.exports = __webpack_public_path__ + "img/marketplace.c313dfeb.gif";